<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page -->
            <h1 class="page__title">{{ title_page }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body position-relative">
            <CModal
                :title="$t('options_list')"
                color="secondary"
                :show.sync="modals.optionsList.show"
                :closeOnBackdrop="false"
            >
                <CContainer fluid>
                    <CTextarea
                        :placeholder="$t('add_list_of_options')"
                        :value.sync="modals.optionsList.data.optionsValue"
                        size="sm"
                    >
                    </CTextarea>
                </CContainer>
                <template #footer>
                    <!-- Button close modal -->
                    <CButton
                        color="secondary"
                        :title="$t('close')"
                        @click="
                            closeModal({
                                modalName: 'optionsList',
                            })
                        "
                    >
                        {{ $t("close") }}
                    </CButton>
                    <!-- Button save modal -->
                    <CButton
                        color="secondary"
                        :title="$t('save')"
                        @click="saveOptionsList()"
                    >
                        {{ $t("save") }}
                    </CButton>
                </template>
            </CModal>
            <CModal
                :title="$t('options_notinlist')"
                color="secondary"
                :show.sync="modals.optionsNotinList.show"
                :closeOnBackdrop="false"
            >
                <CContainer fluid>
                    <CTextarea
                        :placeholder="$t('add_list_of_options')"
                        :value.sync="modals.optionsNotinList.data.optionsValue"
                        size="sm"
                    >
                    </CTextarea>
                </CContainer>
                <template #footer>
                    <!-- Button close modal -->
                    <CButton
                        color="secondary"
                        :title="$t('close')"
                        @click="
                            closeModal({
                                modalName: 'optionsNotinList',
                            })
                        "
                    >
                        {{ $t("close") }}
                    </CButton>
                    <!-- Button save modal -->
                    <CButton
                        color="secondary"
                        :title="$t('save')"
                        @click="saveOptionsNotinList()"
                    >
                        {{ $t("save") }}
                    </CButton>
                </template>
            </CModal>
            <CContainer fluid>
                <CRow>
                    <CCol sm="12">
                        <CCard>
                            <CCardBody>
                                <CTabs variant="tabs" :active-tab="0">
                                    <!--  Tab General -->
                                    <CTab :title="$t('general')">
                                        <CCard bodyWrapper>
                                            <CInput
                                                :isValid="
                                                    checkIfFormValid({
                                                        form_name: 'general',
                                                        field_name: 'name',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.general.name.$model
                                                "
                                                :label="$t('name')"
                                                :placeholder="
                                                    $t('enter_the_name')
                                                "
                                                :invalidFeedback="
                                                    $t('name_is_required')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <CTextarea
                                                :isValid="
                                                    checkIfFormValid({
                                                        form_name: 'general',
                                                        field_name:
                                                            'description',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.general.description
                                                        .$model
                                                "
                                                :label="$t('description')"
                                                :placeholder="
                                                    $t('enter_the_description')
                                                "
                                                :invalidFeedback="
                                                    $t(
                                                        'description_is_required'
                                                    )
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <SelectCountry
                                                :isValid="
                                                    checkIfFormValid({
                                                        form_name: 'general',
                                                        field_name:
                                                            'country_id',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.general.country_id
                                                        .$model
                                                "
                                                :label="$t('country')"
                                                :placeholder="
                                                    $t('select_an_option')
                                                "
                                                :invalidFeedback="
                                                    $t('country_is_required')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <SelectLanguage
                                                :isValid="
                                                    checkIfFormValid({
                                                        form_name: 'general',
                                                        field_name:
                                                            'language_id',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.general.language_id
                                                        .$model
                                                "
                                                :label="$t('language')"
                                                :placeholder="
                                                    $t('select_an_option')
                                                "
                                                :invalidFeedback="
                                                    $t('language_is_required')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />

                                            <CCSwitch
                                                :checked.sync="$v.forms.general
                                                                .active.$model"
                                                :label="$t('Active')"
                                                :horizontal="{
                                                    label: 'col-sm-2',
                                                    input: 'col-sm-10',
                                                }"
                                                color="primary"
                                                name="action"
                                                shape="pill"
                                                variant="3d"
                                                size="sm"
                                            />

                                            <CCSwitch
                                                :checked.sync="$v.forms.general
                                                                .advance_validation
                                                                .$model"
                                                :label="$t('Advance validation')"
                                                :horizontal="{
                                                    label: 'col-sm-2',
                                                    input: 'col-sm-10',
                                                }"
                                                color="primary"
                                                name="action"
                                                shape="pill"
                                                variant="3d"
                                                size="sm"
                                            />

                                            <FormSection>
                                                <FormSectionDescription
                                                    :title="
                                                        $t('Automatic phone validation')
                                                    "
                                                    :sortDescription="
                                                        $t(
                                                            'Validates phone connectivity by checking recent activity on a telephone network. While it does not guarantee reachability, it significantly increases confidence in number validity. Validation can be performed synchronously in real time (with potential impact on response time) or asynchronously in the background (with delayed results).'
                                                        )
                                                    "
                                                />
                                                <CCSwitch
                                                    :checked.sync="$v.forms.general
                                                                    .automatic_phone_validation_status
                                                                    .$model"
                                                    :label="$t('Automatic phone validation active')"
                                                    :horizontal="{
                                                        label: 'col-sm-2',
                                                        input: 'col-sm-10',
                                                    }"
                                                    color="primary"
                                                    name="action"
                                                    shape="pill"
                                                    variant="3d"
                                                    size="sm"
                                                />

                                                <CSelect
                                                    :value.sync="
                                                        $v.forms.general
                                                            .automatic_phone_validation_mode
                                                            .$model
                                                    "
                                                    :options="['sync', 'async']"
                                                    size="sm"
                                                    :placeholder="
                                                        $t('Select an option')
                                                    "
                                                    :horizontal="default_horizontal"
                                                    :isValid="
                                                        checkIfFormValid({
                                                            form_name: 'general',
                                                            field_name:
                                                                'automatic_phone_validation_mode',
                                                        })
                                                    "
                                                    :label="
                                                        $t(
                                                            'Automatick phone validation mode'
                                                        )
                                                    "
                                                    :disabled="
                                                        !forms.general
                                                            .automatic_phone_validation_status
                                                    "
                                                />

                                            </FormSection>

                                            
                                            <FormSection>
                                                <FormSectionDescription
                                                    :title="
                                                        $t('Autocomplete geolocation')
                                                    "
                                                    :sortDescription="
                                                        $t(
                                                            'Enables geographic autocomplete by inferring province or region from minimal user input (e.g. postal code), though results are not guaranteed if the provided data is insufficient or unmatched.'
                                                        )
                                                    "
                                                />
                                                <CCSwitch
                                                    :checked.sync="$v.forms.general
                                                                    .autocomplete_geolocation_status
                                                                    .$model"
                                                    :label="$t('Autocomplete geolocation active')"
                                                    :horizontal="{
                                                        label: 'col-sm-2',
                                                        input: 'col-sm-10',
                                                    }"
                                                    color="primary"
                                                    name="action"
                                                    shape="pill"
                                                    variant="3d"
                                                    size="sm"
                                                />
                                            </FormSection>

                                            

                                            <CInput
                                                :isValid="
                                                    checkIfFormValid({
                                                        form_name: 'general',
                                                        field_name:
                                                            'cost_price',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.general.cost_price
                                                        .$model
                                                "
                                                :label="$t('cost_price')"
                                                :placeholder="
                                                    $t('enter_the_cost_price')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />

                                            <SelectAsync
                                                :placeholder="
                                                    $t(
                                                        'Select a delivery campaign'
                                                    )
                                                "
                                                :horizontal="default_horizontal"
                                                :label="$t('Direct delivery')"
                                                :optionsValue="'Id'"
                                                :optionsLabel="'Name'"
                                                :value.sync="
                                                    $v.forms.general
                                                        .delivery_campaign_id
                                                        .$model
                                                "
                                                :resetOption="true"
                                                size="sm"
                                                endpoint="delivery-campaigns"
                                                matchResponseItems="data.items"
                                                :fetchConfig="{
                                                    baseURL: ApiSass,
                                                    params: {
                                                        query: {
                                                            where: {
                                                                Archive: {
                                                                    equal: false 
                                                                },
                                                            },
                                                        },
                                                    },
                                                }"
                                            />

                                            <SelectAsync
                                                :placeholder="
                                                    $t('Select a group')
                                                "
                                                :horizontal="default_horizontal"
                                                :label="$t('Group')"
                                                :optionsValue="'id'"
                                                :optionsLabel="'name'"
                                                :value.sync="
                                                    $v.forms.general
                                                        .client_group_id.$model
                                                "
                                                :resetOption="true"
                                                size="sm"
                                                endpoint="/shipment.balancing.api/client-groups/"
                                            />
                                        </CCard>
                                    </CTab>
                                    <!-- Tab Integration -->
                                    <CTab
                                        :title="$t('integration')"
                                        :disabled="view_type == 'new'"
                                    >
                                        <CCard bodyWrapper>
                                            <h5>
                                                {{ $t("api_key") }}
                                            </h5>
                                            <h6>
                                                {{
                                                    $t(
                                                        "Unique identifier for this input, with this id Leadgrease you will know to which input the sent parameters correspond"
                                                    )
                                                }}
                                            </h6>
                                            <CCol sm="12 mt-3 mb-3">
                                                <JumBotronAdvance
                                                    :id="
                                                        $v.forms.integration
                                                            .api_key.$model
                                                    "
                                                    size="sm"
                                                    readonly
                                                />
                                            </CCol>

                                            <h6>
                                                {{
                                                    $t(
                                                        "create_ a_list_with_the_parameters_you_want_to_capture_with_this_input"
                                                    )
                                                }}
                                            </h6>
                                            <CustomTable
                                                class="table-overflow-x-initial"
                                                :addTableClasses="['table--sm']"
                                                v-if="
                                                    tables.integration.items
                                                        .length > 0
                                                "
                                                :items="
                                                    tables.integration.items
                                                "
                                                :fields="
                                                    traslateLabels(
                                                        tables.integration
                                                            .fields
                                                    )
                                                "
                                                :resizable="false"
                                                hover
                                                border
                                                striped
                                            >
                                                <template #id="{ index }">
                                                    {{ index + 1 }}
                                                </template>
                                                <template #field_id="{ index }">
                                                    <SelectFields
                                                        :isValid="
                                                            checkIfFormTableValid(
                                                                {
                                                                    table_name:
                                                                        'integration',
                                                                    index,
                                                                    field_name:
                                                                        'field_id',
                                                                }
                                                            )
                                                        "
                                                        :placeholder="
                                                            $t('select_a_field')
                                                        "
                                                        typeSelect="SearchSelect"
                                                        :value.sync="
                                                            $v.tables
                                                                .integration
                                                                .items.$each
                                                                .$iter[index]
                                                                .field_id.$model
                                                        "
                                                        size="sm"
                                                        uses="INPUT"
                                                        :advanceMode="
                                                            stringToBoolean(
                                                                forms.general
                                                                    .advance_validation
                                                            )
                                                        "
                                                    />
                                                </template>
                                                <template #mapping="{ index }">
                                                    <CInput
                                                        :isValid="
                                                            checkIfFormTableValid(
                                                                {
                                                                    table_name:
                                                                        'integration',
                                                                    index,
                                                                    field_name:
                                                                        'mapping',
                                                                }
                                                            )
                                                        "
                                                        :value.sync="
                                                            $v.tables
                                                                .integration
                                                                .items.$each
                                                                .$iter[index]
                                                                .mapping.$model
                                                        "
                                                        :placeholder="
                                                            $t(
                                                                'enter_the_mapping'
                                                            )
                                                        "
                                                        size="sm"
                                                    />
                                                </template>
                                                <template
                                                    #default_value="{ index }"
                                                >
                                                    <CInput
                                                        :isValid="
                                                            checkIfFormTableValid(
                                                                {
                                                                    table_name:
                                                                        'integration',
                                                                    index,
                                                                    field_name:
                                                                        'default_value',
                                                                }
                                                            )
                                                        "
                                                        :value.sync="
                                                            $v.tables
                                                                .integration
                                                                .items.$each
                                                                .$iter[index]
                                                                .default_value
                                                                .$model
                                                        "
                                                        :placeholder="
                                                            $t(
                                                                'enter_the_default_value'
                                                            )
                                                        "
                                                        size="sm"
                                                    />
                                                </template>
                                                <template #required="{ item }">
                                                    <CInputCheckbox
                                                        :checked.sync="
                                                            item.required
                                                        "
                                                    />
                                                </template>
                                                <template #options="{ index }">
                                                    <CButton
                                                        color="primary"
                                                        variant="outline"
                                                        square
                                                        class="mr-1"
                                                        size="sm"
                                                        @click="
                                                            tables.integration.items[
                                                                index
                                                            ]._toggled =
                                                                !tables
                                                                    .integration
                                                                    .items[
                                                                    index
                                                                ]._toggled
                                                        "
                                                        :title="$t('settings')"
                                                    >
                                                        <CIcon
                                                            :content="
                                                                $options.icons
                                                                    .cilSettings
                                                            "
                                                        />
                                                    </CButton>
                                                    <CButton
                                                        color="success"
                                                        variant="outline"
                                                        square
                                                        class="mr-1"
                                                        size="sm"
                                                        @click="
                                                            saveProviderRelationField(
                                                                index
                                                            )
                                                        "
                                                        :title="$t('save')"
                                                    >
                                                        <CIcon
                                                            :content="
                                                                $options.icons
                                                                    .cilSave
                                                            "
                                                        />
                                                    </CButton>
                                                    <CButton
                                                        color="danger"
                                                        variant="outline"
                                                        square
                                                        size="sm"
                                                        @click="
                                                            deleteProviderRelationField(
                                                                index
                                                            )
                                                        "
                                                        :title="$t('delete')"
                                                    >
                                                        <CIcon
                                                            :content="
                                                                $options.icons
                                                                    .cilTrash
                                                            "
                                                        />
                                                    </CButton>
                                                </template>
                                                <template
                                                    #details="{ item}"
                                                >
                                                    <CCollapse
                                                        :show="
                                                            Boolean(
                                                                item._toggled
                                                            )
                                                        "
                                                    >
                                                        <CCardBody>
                                                            <CRow>
                                                                <CCol>
                                                                    <h5>
                                                                        {{
                                                                            $t(
                                                                                "filters"
                                                                            )
                                                                        }}
                                                                    </h5>
                                                                    <p
                                                                        class="mb-0"
                                                                    >
                                                                        {{
                                                                            $t(
                                                                                "set_filters_in_field"
                                                                            )
                                                                        }}.
                                                                    </p>
                                                                    <CCTableAddItems
                                                                        :addTableClasses="[
                                                                            'table--sm',
                                                                        ]"
                                                                        :items="
                                                                            item.filters
                                                                        "
                                                                        :fields="[
                                                                                {
                                                                                    key: 'condition',
                                                                                    label: 'condition',
                                                                                },
                                                                                {
                                                                                    key: 'value',
                                                                                    label: 'value',
                                                                                }
                                                                            ]
                                                                        "
                                                                        hover
                                                                        border
                                                                        striped
                                                                    >
                                                                        <template
                                                                            #condition="{
                                                                                index,
                                                                            }"
                                                                        >
                                                                            <CSelect
                                                                                :value.sync="
                                                                                    item
                                                                                        .filters[
                                                                                        index
                                                                                    ]
                                                                                        .condition
                                                                                "
                                                                                :options="
                                                                                    traslateArrayObjects(
                                                                                        {
                                                                                            array: $options
                                                                                                .options
                                                                                                .FilterTypeOptions,
                                                                                            fields: [
                                                                                                'label',
                                                                                            ],
                                                                                        }
                                                                                    )
                                                                                "
                                                                                :placeholder="
                                                                                    $t(
                                                                                        'select_an_option'
                                                                                    )
                                                                                "
                                                                                :invalidFeedback="
                                                                                    $t(
                                                                                        'Field is required'
                                                                                    )
                                                                                "
                                                                                class="mb-0"
                                                                                size="sm"
                                                                            />
                                                                        </template>
                                                                        <template
                                                                            #value="{
                                                                                index,
                                                                            }"
                                                                        >
                                                                            <CButton
                                                                                v-if="
                                                                                    item
                                                                                        .filters[
                                                                                        index
                                                                                    ]
                                                                                        .condition ==
                                                                                    'list'
                                                                                "
                                                                                :block="
                                                                                    true
                                                                                "
                                                                                color="secondary"
                                                                                variant="outline"
                                                                                @click="
                                                                                    openModal(
                                                                                        {
                                                                                            modalName:
                                                                                                'optionsList',
                                                                                            data: {
                                                                                                idItemSelected:
                                                                                                    index,
                                                                                                item: item,
                                                                                                uuidFilterSelected:
                                                                                                    item
                                                                                                        .filters[
                                                                                                        index
                                                                                                    ]
                                                                                                        .uuid,
                                                                                            },
                                                                                            callback:
                                                                                                initModalOptionsList,
                                                                                        }
                                                                                    )
                                                                                "
                                                                            >
                                                                                {{
                                                                                    $t(
                                                                                        "options_list"
                                                                                    )
                                                                                }}
                                                                            </CButton>
                                                                            <CButton
                                                                                v-else-if="
                                                                                    item
                                                                                        .filters[
                                                                                        index
                                                                                    ]
                                                                                        .condition ==
                                                                                    'not_in_list'
                                                                                "
                                                                                :block="
                                                                                    true
                                                                                "
                                                                                color="secondary"
                                                                                variant="outline"
                                                                                @click="
                                                                                    openModal(
                                                                                        {
                                                                                            modalName:
                                                                                                'optionsNotinList',
                                                                                            data: {
                                                                                                idItemSelected:
                                                                                                    index,
                                                                                                item: item,
                                                                                                uuidFilterSelected:
                                                                                                    item
                                                                                                        .filters[
                                                                                                        index
                                                                                                    ]
                                                                                                        .uuid,
                                                                                            },
                                                                                            callback:
                                                                                                initModalOptionsNotinList,
                                                                                        }
                                                                                    )
                                                                                "
                                                                            >
                                                                                {{
                                                                                    $t(
                                                                                        "options_notinlist"
                                                                                    )
                                                                                }}
                                                                            </CButton>
                                                                            <CInput
                                                                                v-else
                                                                                :value.sync="
                                                                                    item
                                                                                        .filters[
                                                                                        index
                                                                                    ]
                                                                                        .value
                                                                                "
                                                                                :placeholder="
                                                                                    $t(
                                                                                        'enter_the_value'
                                                                                    )
                                                                                "
                                                                                :invalidFeedback="
                                                                                    $t(
                                                                                        'value_is_required'
                                                                                    )
                                                                                "
                                                                                class="mb-0"
                                                                                size="sm"
                                                                            />
                                                                        </template>
                                                                    </CCTableAddItems>
                                                                </CCol>
                                                            </CRow>
                                                        </CCardBody>
                                                    </CCollapse>
                                                </template>
                                            </CustomTable>
                                            <CButton
                                                color="success"
                                                class="button m-2"
                                                :title="$t('add_field')"
                                                @click="
                                                    addProviderRelationField()
                                                "
                                            >
                                                <span class="button__icon">
                                                    <CIcon
                                                        :content="
                                                            $options.icons
                                                                .cilPlus
                                                        "
                                                    />
                                                </span>
                                                <span class="button__text">
                                                    {{ $t("add_field") }}
                                                </span>
                                            </CButton>
                                        </CCard>
                                    </CTab>
                                    <!-- Tab Databases -->
                                    <CTab
                                        :title="$t('databases')"
                                        :disabled="view_type == 'new'"
                                    >
                                        <ProviderDatabasesTab
                                            v-if="view_type != 'new'"
                                            :providerId="this.forms.general.id"
                                            :providerUuid="this.providerUuid"
                                        />
                                    </CTab>
                                    <!-- Capping -->
                                    <CTab :title="$t('capping')">
                                        <CCard bodyWrapper>
                                            <h6>
                                                {{ $t("capping_description") }}
                                            </h6>
                                            <CSelect
                                                :isValid="
                                                    checkIfFormValid({
                                                        form_name: 'capping',
                                                        field_name:
                                                            'capping_interval',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.capping
                                                        .capping_interval.$model
                                                "
                                                :options="
                                                    traslateLabels(
                                                        $options.options
                                                            .capping_interval
                                                    )
                                                "
                                                :label="$t('capping_interval')"
                                                :placeholder="
                                                    $t('select_an_option')
                                                "
                                                :invalidFeedback="
                                                    $t(
                                                        'capping_interval_is_required'
                                                    )
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <CInput
                                                :isValid="
                                                    checkIfFormValid({
                                                        form_name: 'capping',
                                                        field_name: 'capping',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.capping.capping
                                                        .$model
                                                "
                                                :label="$t('capping_limit')"
                                                :placeholder="
                                                    $t('enter_the_capping')
                                                "
                                                :invalidFeedback="
                                                    $t('requires_a_number')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />

                                            <CInput
                                                :isValid="
                                                    checkIfFormValid({
                                                        form_name: 'capping',
                                                        field_name:
                                                            'capping_notification',
                                                    })
                                                "
                                                :value.sync="
                                                    $v.forms.capping
                                                        .capping_notification
                                                        .$model
                                                "
                                                :label="
                                                    $t('capping_notification')
                                                "
                                                :placeholder="
                                                    $t(
                                                        'enter_the_capping_notification'
                                                    )
                                                "
                                                :invalidFeedback="
                                                    $t('requires_a_number')
                                                "
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <FormSection>
                                                <FormSectionDescription
                                                    :title="
                                                        $t('Capping end date')
                                                    "
                                                    :sortDescription="
                                                        $t(
                                                            'You can select the date to end the capping.'
                                                        )
                                                    "
                                                />
                                                <CCSwitch
                                                    :checked.sync="$v.forms.general
                                                                    .capping_end_date.$model"
                                                    :label="$t('Capping end date')"
                                                    :horizontal="{
                                                        label: 'col-sm-2',
                                                        input: 'col-sm-10',
                                                    }"
                                                    color="primary"
                                                    name="action"
                                                    shape="pill"
                                                    variant="3d"
                                                    size="sm"
                                                />
                                                <DatePicker
                                                    v-model="
                                                        $v.forms.general.end_date
                                                            .$model
                                                    "
                                                    :min-date="new Date()"
                                                    :model-config="
                                                        vCalendar.modelConfig
                                                    "
                                                >
                                                    <template
                                                        v-slot="{
                                                            inputValue,
                                                            inputEvents,
                                                        }"
                                                    >
                                                        <CInput
                                                            :isValid="
                                                                checkIfFormValid({
                                                                    form_name:
                                                                        'general',
                                                                    field_name:
                                                                        'end_date',
                                                                })
                                                            "
                                                            :value="inputValue"
                                                            v-on="inputEvents"
                                                            :label="
                                                                $t('End date')
                                                            "
                                                            :placeholder="
                                                                $t('Select a date')
                                                            "
                                                            :invalidFeedback="
                                                                $t(
                                                                    'Date is required'
                                                                )
                                                            "
                                                            :horizontal="
                                                                default_horizontal
                                                            "
                                                            size="sm"
                                                            :disabled="
                                                                !forms.general
                                                                    .capping_end_date
                                                            "
                                                        />
                                                    </template>
                                                </DatePicker>
                                            </FormSection>
                                        </CCard>
                                    </CTab>
                                    <CTab
                                        :title="$t('Optin')"
                                        :disabled="view_type == 'new'"
                                    >
                                        <OptinTab
                                            ref="optinTab"
                                            :providerId="this.forms.general.id"
                                            :providerUuid="this.providerUuid"
                                        />
                                    </CTab>
                                </CTabs>
                            </CCardBody>
                            <CCardFooter class="d-flex">
                                <!-- Button save -->
                                <ButtonSave
                                    color="success"
                                    @click="sendForm()"
                                />
                                <!-- Button back -->
                                <ButtonBack class="ml-2 button" />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>
<script>
import SelectCountry from "£lement/SelectCountry";
import SelectLanguage from "£lement/SelectLanguage";
import ButtonBack from "£lement/ButtonBack";
import ButtonSave from "~/components/ButtonSave";
import JumBotronAdvance from "~/components/JumBotronAdvance";
import CustomTable from "~/components/CustomTable";
import CCTableAddItems from "~/components/CCTableAddItems";
import CCSwitch from "~/components/CCSwitch";
import FormSection from "~/components/FormSection";
import FormSectionDescription from "~/components/FormSectionDescription";

import SelectFields from "£lement/SelectFields";
import SelectFieldsAdvance from "£lement/SelectFieldsAdvance";

import SelectAsync from "£lement/SelectAsync";
import ProviderDatabasesTab from "~/pages/app/campaings/Components/ProviderDatabasesTab";
import OptinTab from "~/pages/app/campaings/Components/OptinTab";
import LInputRadioGroup from "~/components/LInputRadioGroup";
import Calendar from "v-calendar/lib/components/calendar.umd";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import pageMixin from "~/mixins/page.js";
import FilterTypeOptions from "./config/options/filter_type";
import {
    cilSave,
    cilArrowThickFromRight,
    cilPlus,
    cilTrash,
    cilPencil,
    cilSettings,
} from "@coreui/icons";

import { validationMixin } from "vuelidate";
import { required, numeric } from "vuelidate/lib/validators";

import CappingIntervalOptions from "./config/options/capping_interval.js";
import IntegrationsTable from "./config/tables/integrations.js";
import ProviderDatabasesTable from "./config/tables/databases.js";
import GeneralForm from "./config/forms/general.js";
import FieldTypeOptions from "./config/options/field_type.js";
import OptionsListModal from "./config/modals/options_list.js";
import OptionsNotinListModal from "./config/modals/options_notinlist.js";
import modalMixin from "~/mixins/modal.js";
import GeneralFormsValidations from "./config/validations/forms/general.js";
import IntegrationFormsValidations from "./config/validations/forms/integration.js";
import IntegrationTableValidations from "./config/validations/tables/integration.js";

export default {
    name: "CampaignViewPage",
    middleware: ["auth", "page"],
    mixins: [validationMixin, pageMixin, modalMixin],
    components: {
        SelectCountry,
        SelectLanguage,
        SelectFields,
        SelectFieldsAdvance,
        FormSection,
        FormSectionDescription,
        SelectAsync,
        LInputRadioGroup,
        Calendar,
        DatePicker,
        ButtonBack,
        ButtonSave,
        ProviderDatabasesTab,
        JumBotronAdvance,
        CustomTable,
        CCTableAddItems,
        CCSwitch,
        OptinTab,
    },
    icons: {
        cilSave,
        cilPencil,
        cilArrowThickFromRight,
        cilPlus,
        cilTrash,
        cilSettings,
    },
    options: {
        capping_interval: CappingIntervalOptions,
        FilterTypeOptions,
        FieldTypeOptions,
    },
    data() {
        return {
            optionsList: null,
            optionsNotinList: null,
            forms: {
                general: GeneralForm,
                integration: {
                    api_key: null,
                },
                capping: {
                    capping: null,
                    capping_interval: null,
                    capping_notification: null,
                },
                options_list: {
                    value: null,
                },
                options_notinlist: {
                    value: null,
                },
                optin: {
                    optin: false,
                },
            },

            tables: {
                integration: IntegrationsTable,
                databases: ProviderDatabasesTable,
            },
            modals: {
                optionsList: OptionsListModal,
                optionsNotinList: OptionsNotinListModal,
            },
            page: {
                _loading: true,
            },
            vCalendar: {
                modelConfig: {
                    type: "string",
                    mask: "YYYY-MM-DD", // Uses 'iso' if missing
                },
            },
        };
    },
    computed: {
        title_page: function () {
            let title_page = "new_campaign";
            if (this.$route.query.view_type == "edit")
                title_page = "edit_campaign";
            return this.$t(title_page);
        },
        provider_id: function () {
            return this.$route.query.uuid;
        },
        providerUuid: function () {
            return this.$route.query.uuid;
        },
    },
    validations: {
        optionsList: {
            required,
        },
        optionsNotinList: {
            required,
        },
        forms: {
            general: GeneralFormsValidations,
            integration: IntegrationFormsValidations,
            capping: {
                capping: {
                    numeric,
                },
                capping_interval: {},
                capping_notification: {
                    numeric,
                },
            },
            options_list: {
                value: {
                    required,
                },
            },
            options_notinlist: {
                value: {
                    required,
                },
            },
            optin: {
                optin: {},
            },
        },
        tables: {
            integration: IntegrationTableValidations,
        },
    },
    watch: {},
    methods: {
        initModalOptionsList(modal) {
            let fieldItem = this.modals.optionsList.data.item;
            let index = this.tables.integration.items.findIndex(
                (element) => element["id"] == fieldItem.id
            );

            let position = this.tables.integration.items[index][
                "filters"
            ].findIndex(
                (element) =>
                    element["uuid"] ==
                    this.modals.optionsList.data.uuidFilterSelected
            );

            this.modals.optionsList.data.optionsValue =
                this.tables.integration.items[index]["filters"][position].value;
        },
        initModalOptionsNotinList(modal) {
            let fieldItem = this.modals.optionsNotinList.data.item;
            let index = this.tables.integration.items.findIndex(
                (element) => element["id"] == fieldItem.id
            );

            let position = this.tables.integration.items[index][
                "filters"
            ].findIndex(
                (element) =>
                    element["uuid"] ==
                    this.modals.optionsNotinList.data.uuidFilterSelected
            );

            this.modals.optionsNotinList.data.optionsValue =
                this.tables.integration.items[index]["filters"][position].value;
        },
        /* Database */
        async onChangeSelectDatabase(database_id) {
            let url = `/db/${database_id}/provider/rel/${this.provider_id}`;

            await this.sendData({
                url,
                method: "POST",
            });

            this.updateForms();
        },
        async saveRelationDatabase({ database_id, provider_id }) {
            let url = `/db/${database_id}/provider/rel/${provider_id}`;

            await this.sendData({
                url,
                method: "POST",
            });

            this.updateForms();
        },

        addOptionsListToField(value) {
            // console.log(value);
        },

        async loadTableDatabases({ list }) {
            if (!list) {
                return;
            }

            let list_params = list.map((item) => {
                return {
                    url_param: item,
                };
            });

            let databases = await this.loadListData({
                url: "/db",
                list_params,
            });
            this.tables.databases.items = databases;
        },

        sendForm: async function () {
            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
            this.$v.$touch();
            try {
                let invalidOptin = await this.$refs.optinTab.isInvalid();
                if (invalidOptin) {
                    throw {
                        code: 422,
                        message: this.$t("invalid_optin"),
                    };
                }
                if (this.$v.forms.general.$invalid) {
                    throw {
                        code: 422,
                        message: this.$t("invalid_data_general"),
                    };
                }
                if (this.$v.forms.integration.$invalid) {
                    throw {
                        code: 422,
                        message: this.$t("invalid_data_integration"),
                    };
                }
                if (this.$v.forms.capping.$invalid) {
                    throw {
                        code: 422,
                        message: this.$t("invalid_data_capping"),
                    };
                }

                this.updatePageLoading(true);

                let form_general = this.forms.general;
                form_general.active = form_general.active ? 1 : 0;

                this.forms.optin.optin = this.$refs.optinTab.forms.optin.active
                    ? 1
                    : 0;

                let data = {
                    ...form_general,
                    ...this.forms.integration,
                    ...this.forms.capping,
                    ...this.forms.optin,
                };

                let url = "/provider";
                let url_param = this.provider_id;
                let method = url_param ? "PUT" : "POST";
                delete data["id"];
                let resp = await this.sendData({
                    data,
                    url,
                    url_param,
                    method,
                });

                let insertId = null;
                if (resp.insertId) {
                    insertId = resp.insertId;
                }
                await this.$refs.optinTab.sendData(insertId, method);

                if (method == "PUT") {
                    this.$store.dispatch("toast/addFixedToasts", {
                        ...this.$options.messages.update,
                    });
                } else {
                    this.$store.dispatch("toast/addFixedToasts", {
                        ...this.$options.messages.create,
                    });
                }

                this.$router.push({ name: "campaings" });
            } catch (error) {
                this.showMessageError(error);
                this.page._loading = false;
            }
        },

        async updateForms() {
            if (this.view_type && this.view_type == "edit") {
                let form_data = await this.loadData({
                    url: "/provider",
                    url_param: this.provider_id,
                });

                /* Load form general */
                await this.loadForm({
                    form_name: "general",
                    data: form_data,
                });

                /* await this.loadTableDatabases({
                    list: form_data.db,
                }); */

                /* Load form integration */
                await this.loadForm({
                    form_name: "integration",
                    data: form_data,
                });
                /* Load form capping */
                await this.loadForm({
                    form_name: "capping",
                    data: form_data,
                });

                await this.$refs.optinTab.loadOptinDetails();

                await this.loadProviderFields();
            }
            this.updatePageLoading(false);
        },

        /**
         * @description Carga los campos de una entrada
         */
        async loadProviderFields() {
            let data = await this.loadData({
                url: `/input.api/providers/${this.provider_id}/fields`,
            });
            data = data._items.map((item) => {
                let required = item.required;
                if (required == 1 || required == "on") {
                    required = true;
                } else {
                    required = false;
                }
                let filters = [];
                if (item.filters && !Array.isArray(item.filters)) {
                    filters = JSON.parse(item.filters);
                }
                item.field_id = parseInt(item.field_id);
                return {
                    ...item,
                    required,
                    filters,
                    _toggled: false,
                };
            });
            this.tables.integration.items = data;
        },
        addProviderRelationField: function () {
            this.tables.integration.items.push({
                provider_id: this.forms.general.id,
                field_relation: null,
                field_id: null,
                mapping: null,
                field_type: null,
                field_format: null,
                default_value: null,
                required: false,
                filters: [],
                _toggled: false,
            });
        },
        saveProviderRelationField: async function (index) {
            this.$v.tables.integration.items.$each.$iter[index].$touch();
            try {
                if (
                    this.$v.tables.integration.items.$each.$iter[index].$invalid
                ) {
                    throw { code: 422, message: this.$t("invalid_data") };
                }

                let data = { ...this.tables.integration.items[index] };
                // data.required = (data.required) ? 'on':'off';
                // if (data.required) {
                //     data.required = true;
                // } else {
                //     delete data.required;
                // }

                delete data.name;
                data.filters = JSON.stringify(data.filters);
                delete data._toggled;
                data = {
                    ...data,
                };
                let url_param = "";
                let id = data.id;
                let method = id ? "PUT" : "POST";
                let url = "/outgoing.api/providers/update/parameters";
                if (method == "POST") {
                    url = "/input.api/providers/add/parameters";
                }

                let res = await this.sendData({
                    data,
                    url,
                    url_param,
                    method,
                });
                if (res._items && res._items.insertId) {
                    this.tables.integration.items[index].id =
                        res._items.insertId;
                    if (data.required == "on") {
                        this.saveProviderRelationField(index);
                    }
                }
                this.$v.tables.integration.items.$each.$iter[index].$reset();
                if (method == "PUT") {
                    this.$store.dispatch("toast/addFixedToasts", {
                        ...this.$options.messages.update,
                    });
                } else {
                    this.$store.dispatch("toast/addFixedToasts", {
                        ...this.$options.messages.create,
                    });
                }
            } catch (error) {
                this.showMessageError(error);
            }
        },
        deleteProviderRelationField: async function (index) {
            let item = this.tables.integration.items[index];
            try {
                if (item.id) {
                    await this.deleteData({
                        url: "/provider/relation/field",
                        url_param: item.id,
                    });
                }
                this.tables.integration.items.splice(index, 1);
            } catch (error) {}
        },
        deleteProviderDb: async function (index) {
            let item = this.tables.databases.items[index];
            try {
                if (item.id && this.forms.general.id) {
                    let url = "/db.api/:db_id/provider/rel/:provider_id";
                    url = this.replaceURLParams(url, {
                        db_id: item.id,
                        provider_id: this.forms.general.id,
                    });
                    await this.deleteData({
                        url,
                    });
                    this.tables.databases.items.splice(index, 1);
                }
            } catch (error) {}
        },
        saveOptionsList() {
            try {
                let fieldItem = this.modals.optionsList.data.item;
                let index = this.tables.integration.items.findIndex(
                    (element) => element["id"] == fieldItem.id
                );

                let position = this.tables.integration.items[index][
                    "filters"
                ].findIndex(
                    (element) =>
                        element["uuid"] ==
                        this.modals.optionsList.data.uuidFilterSelected
                );

                this.tables.integration.items[index]["filters"][
                    position
                ].value = this.modals.optionsList.data.optionsValue;
                this.modals.optionsList.show = false;
            } catch (error) {
                this.showMessageError(error);
            }
        },
        saveOptionsNotinList() {
            try {
                let fieldItem = this.modals.optionsNotinList.data.item;
                let index = this.tables.integration.items.findIndex(
                    (element) => element["id"] == fieldItem.id
                );

                let position = this.tables.integration.items[index][
                    "filters"
                ].findIndex(
                    (element) =>
                        element["uuid"] ==
                        this.modals.optionsNotinList.data.uuidFilterSelected
                );

                this.tables.integration.items[index]["filters"][
                    position
                ].value = this.modals.optionsNotinList.data.optionsValue;
                this.modals.optionsNotinList.show = false;
            } catch (error) {
                this.showMessageError(error);
            }
        },
        generateUUID() {
            function uuidv4() {
                return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(
                    /[018]/g,
                    (c) =>
                        (
                            c ^
                            (crypto.getRandomValues(new Uint8Array(1))[0] &
                                (15 >> (c / 4)))
                        ).toString(16)
                );
            }
            return uuidv4();
        },

        addFilter(index) {
            this.tables.integration.items[index].filters.push({
                uuid: this.generateUUID(),
                condition: null,
                value: null,
            });
        },
        deleteFilter(index, filterUuid) {
            let findFilter = this.tables.integration.items[
                index
            ].filters.findIndex((filter) => filter.uuid == filterUuid);
            if (findFilter > -1) {
                this.tables.integration.items[index].filters.splice(
                    findFilter,
                    1
                );
            }
        },
    },
    mounted() {
        this.updateForms();
    },
    created() {
        this.loadFields();
        this.loadFieldsAdvance();
    },
};
</script>

<style scoped lang="scss"></style>
